import { useQuery } from 'react-query';
import { messagesAPI } from '../apiClient';

export default function ServiceCallLinkPicker({
  technicianId = null,
  selectedCallId = null,
  selectedCallLabel = null,
  onSelect,
  onClear,
  disabled = false,
}) {
  const { data: calls = [], isLoading } = useQuery(
    ['linkableServiceCalls', technicianId],
    async () => {
      const response = await messagesAPI.getLinkableServiceCalls({
        technicianId: technicianId || undefined,
        limit: 20,
      });
      return response.data?.serviceCalls || [];
    },
    {
      enabled: !disabled,
      staleTime: 60000,
    }
  );

  if (selectedCallLabel) {
    return (
      <div className="mb-2 flex items-center justify-between gap-2 rounded-md border border-primary-200 bg-primary-50 px-2.5 py-1.5 text-xs text-primary-800">
        <span className="truncate">Re: {selectedCallLabel}</span>
        {onClear && (
          <button
            type="button"
            onClick={onClear}
            className="flex-shrink-0 text-primary-600 hover:text-primary-800"
          >
            Remove
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="mb-2">
      <label htmlFor="service-call-link" className="mb-1 block text-2xs font-medium text-gray-500">
        Link to service call (optional)
      </label>
      <select
        id="service-call-link"
        disabled={disabled || isLoading || calls.length === 0}
        defaultValue=""
        onChange={(e) => {
          const callId = e.target.value;
          if (!callId) return;
          const call = calls.find((item) => item.id === callId);
          onSelect?.({ serviceCallId: callId, serviceCallLabel: call?.label || 'Service call' });
          e.target.value = '';
        }}
        className="w-full rounded-lg border border-slate-200 px-2.5 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-50"
      >
        <option value="">
          {isLoading ? 'Loading calls…' : calls.length === 0 ? 'No recent calls to link' : 'Select a service call…'}
        </option>
        {calls.map((call) => (
          <option key={call.id} value={call.id}>
            {call.label}{call.status ? ` (${call.status.replace('_', ' ')})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
